import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@babel/polyfill";
import "amfe-flexible";
import axios from "./utils/axios";
import "./assets/iconfont/iconfont.css"; //iconfont图标
import Vant from "vant";
import "vant/lib/index.css";
import { Toast } from "vant";
import h5Header from "@/components/header/header";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import store from "@/store";
import BaiduMap from "vue-baidu-map";
import VideoPlayer from "vue-video-player";
import VueMeta from 'vue-meta';
import VConsole from 'vconsole'; // 引入vconsole

// 创建一个VConsole实例
// const vconsole = new VConsole();
Vue.use(VueMeta);
// import 'video.js/dist/video-js.css'

// Vue.use(VideoPlayer)
Vue.use(Vant);
Vue.use(Toast, { duration: 1000 });
Vue.use(BaiduMap, {
  /* 需要注册百度地图开发者来获取你的ak */
  ak: "XBhQ8xfErr3pmn1vIzX1ntI6b4Sv2LYH",
});
Vue.prototype.$axios = axios;
Vue.component("h5-header", h5Header);
Vue.config.productionTip = false;
if (process.env.NODE_ENV === 'development') {
  console.log('开发环境');
  // const VConsole = require('vconsole'); // 动态导入vconsole
  // new VConsole();
}
process.env.NODE_ENV === "production" &&
  Sentry.init({
    dsn: "https://a419d06957ad4f25b59dcd18fd9e9c44@sentry.io/1852207",
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    release: "test@1.0.1",
    logErrors: true,
  });
Vue.prototype.GetQueryString = function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.href.split("?")[1] ? window.location.href.split("?")[1].match(reg) : null;
  if (r != null) return decodeURIComponent(r[2]);
  return null;
};
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8"; // 添加POST请求头

if (window.location.host == "192.168.1.66") {
  //测试环境
  axios.defaults.baseURL = "http://" + window.location.host + "/app/"; //接口请求链接前缀
  Vue.prototype.prefixURL = "http://" + window.location.host + "/app/"; //分享链接前缀（分享到悦买）
  Vue.prototype.imgPrex = "http://192.168.1.66/ejsimage"; //图片服务器前缀
} else if (window.location.host.indexOf("192.168.1.58") != -1) {
  //测试环境
  axios.defaults.baseURL = "http://" + window.location.host + "/app/"; //接口请求链接前缀
  Vue.prototype.prefixURL = "http://" + window.location.host + "/app/"; //分享链接前缀（分享到悦买）
  Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
} else if (window.location.host.indexOf("192.168.1.67") != -1) {
  //测试环境
  console.log('indexOf 192.168.1.67');
  // if (Vue.prototype.GetQueryString("source") && Vue.prototype.GetQueryString("source") == "1") {
  //   axios.defaults.baseURL = "http://192.168.1.67/";
  // } else {
  //   axios.defaults.baseURL = "http://192.168.1.67/app/"; 
  // }
  // Vue.prototype.prefixURL = "http://192.168.1.67";
  // Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
} else if (window.location.host.indexOf("192.168.1.59") != -1) {  // app H5测试环境，需要source传入2
  // http://192.168.1.59:7210 加个app(http://192.168.1.59:7210/app) 等同于http://192.168.1.58:8080/app
  if (Vue.prototype.GetQueryString("source") && Vue.prototype.GetQueryString('source') == 2) {
    // 卖家/行家，历史遗留问题，只能在2的基础新增一个type=expert判断是行家还是卖家
    if (Vue.prototype.GetQueryString('type') == 'expert') { // 行家
      axios.defaults.baseURL = "http://192.168.1.60:8112/";
      Vue.prototype.prefixURL = `http://192.168.1.60:8112/`;
    } else {  // 卖家
      axios.defaults.baseURL = "http://192.168.1.56:7212/";
      Vue.prototype.prefixURL = `http://192.168.1.56:7212/`;
    }
  } else if (Vue.prototype.GetQueryString("source") && Vue.prototype.GetQueryString('source') == 1) {  // 买家
    axios.defaults.baseURL = "http://192.168.1.59:7210/app";
    Vue.prototype.prefixURL = `http://192.168.1.59:7210/app`;
  }

  Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
} else if (
  window.location.host.indexOf("localhost") != -1 ||
  window.location.host.indexOf("127.0.0.1") != -1 ||
  window.location.host.indexOf("192.168") != -1
) {
  if (Vue.prototype.GetQueryString("source") && Vue.prototype.GetQueryString('source') == 2) {
    // 卖家
    axios.defaults.baseURL = "http://192.168.1.56:7212/";
  } else {
    //本地环境
    axios.defaults.baseURL = "/dev/";
  }

  // axios.defaults.baseURL = "http://192.168.1.58:3000/mock/79/";
  //axios.defaults.baseURL = "http://192.168.1.66/app/";
  // Vue.prototype.prefixURL = "http://yapi.yamyamyam.test/mock/21/";
  // Vue.prototype.imgPrex = "http://192.168.1.66/ejsimage";//图片服务器前缀
  Vue.prototype.prefixURL = `http://192.168.1.56:7212/`;
  Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
}
// else if (window.location.host.indexOf("testymstatic.yamyamyam.com") != -1) {
//   //预线上环境
//   axios.defaults.baseURL = "https://testymapi.yamyamyam.com/";
//   Vue.prototype.prefixURL = "https://testapp.yamyamyam.com/";
//   Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
//   Vue.prototype.baseURL = "https://testapp.yamyamyam.com/";
// }
else if (window.location.host.indexOf("testymstatic.yamyamyam.com") != -1) {
  //预线上环境
  axios.defaults.baseURL = "https://testapp.yamyamyam.com/";
  Vue.prototype.prefixURL = "https://testapp.yamyamyam.com/";
  Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
} else if (window.location.host.indexOf("csapi.yamyamyam.com") != -1) {
  //华为云app测试环境
  axios.defaults.baseURL = "https://csapi.yamyamyam.com/"; //接口请求链接前缀
  Vue.prototype.prefixURL = "https://csapi.yamyamyam.com/"; ///分享链接前缀（分享到悦买）
  Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
} else if (window.location.host.indexOf("csmp.yamyamyam.com") != -1) {
  //华为云小程序测试环境
  axios.defaults.baseURL = "https://csmp.yamyamyam.com/"; //接口请求链接前缀
  Vue.prototype.prefixURL = "https://csmp.yamyamyam.com/"; ///分享链接前缀（分享到悦买）
  Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
} else if (window.location.host.indexOf("csm.yamyamyam.com") != -1) {
  //华为云H5测试环境
  axios.defaults.baseURL = "https://csm.yamyamyam.com/"; //接口请求链接前缀
  Vue.prototype.prefixURL = "https://csm.yamyamyam.com/"; ///分享链接前缀（分享到悦买）
  Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
} else if (window.location.host.indexOf("ymstatic.yamyamyam.com") != -1) {
  //正式环境
  if (Vue.prototype.GetQueryString("source") && Vue.prototype.GetQueryString("source") == "1") {
    // 买家之一
    axios.defaults.baseURL = "https://api.yamyamyam.com/";
    Vue.prototype.prefixURL = `https://api.yamyamyam.com/`;
    Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
    Vue.prototype.baseURL = "https://api.yamyamyam.com/";
  } else if (Vue.prototype.GetQueryString("source") && Vue.prototype.GetQueryString('source') == 2) {
    // 卖家
    if (Vue.prototype.GetQueryString('type') == 'expert') { // 行家
      axios.defaults.baseURL = "https://expert.yamyamyam.com/"; //接口请求链接前缀
      Vue.prototype.prefixURL = "https://expert.yamyamyam.com/"; ///分享链接前缀（分享到悦买）
      Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
      Vue.prototype.baseURL = "https://expert.yamyamyam.com/";
    } else {  // 卖家
      axios.defaults.baseURL = "https://ymapi.yamyamyam.com/"; //接口请求链接前缀
      Vue.prototype.prefixURL = "https://ymapi.yamyamyam.com/"; ///分享链接前缀（分享到悦买）
      Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
      Vue.prototype.baseURL = "https://ymapi.yamyamyam.com/";
    }
  } else {
    axios.defaults.baseURL = "https://api.yamyamyam.com/"; //接口请求链接前缀
    Vue.prototype.prefixURL = "https://api.yamyamyam.com/"; ///分享链接前缀（分享到悦买）
    Vue.prototype.imgPrex = "http://img.yamyamyam.com"; //图片服务器前缀
    Vue.prototype.baseURL = "https://api.yamyamyam.com/";
  }
}

// router.beforeEach((to, from, next) => {
//   if (to.path === "/presellIndex") {

//   } else {
//     next()
//   }
// })
//

// 'd328ea99-025d-4d39-826f-98eddd746876#13#1576724277883'
// 获取token的vuex状态
let tk = store.getters.token || Vue.prototype.GetQueryString("token");

let host = window.location.href
  .split("?")[0]
  .split("//")[1]
  .split("/")[0]
  .split(":")[0];
document.cookie = `thetoken=${tk};domain=${host};path=/`;
// axios.interceptors.request.use(function (config) {
//   // let token = tk
//   // let token = 'member_token_46b94033-b46a-48dd-80af-49216141dfad#TIMESTAMP1577072836277#SOURCE2#ID1835272034'
//   if (config.data == '' || config.data == null || config.data == undefined) {
//     if (token) {
//       config.params['token'] = tk
//     }
//     return config
//   } else {
//     if (token) {
//       config.data['token'] = tk
//     }
//     console.log(config)
//     return config
//   }

// }, function (error) {
//   return Promise.reject(error)
// })

router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  store.commit("user/SET_url", from.path == "/" ? "" : from.path);
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  next();
});
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
